import { spacing } from '@ardoq/design-tokens';
import { Stack } from '@ardoq/layout';
import styled from 'styled-components';

export const SurveyDescription = styled.div`
  width: 100%;
  p {
    margin: 0;
  }
  p:not(:last-child) {
    margin-bottom: ${spacing.s16};
  }
  overflow-y: auto;
`;

export const FullWidthStack = styled(Stack)`
  width: 100%;
`;
